(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["route-race-picker"] && !Shopify.designMode) return;
  try {
    class RouteRacePicker extends HTMLElement {
    connectedCallback() {
      try {
        this.races = JSON.parse(this.querySelector('[data-races]').textContent);
      } catch (error) {
        this.races = [];
      }
      this.race = this.querySelector('[data-race]');
      this.distance = this.querySelector('[data-distance]');
      this.go = this.querySelector('[data-go]');
      this.race.addEventListener('change', () => this.fill());
      this.distance.addEventListener('change', () => {
        this.update();
        if (this.distance.value) this.go.focus();
      });
      // the browser may restore the race on "back"
      if (this.race.value) this.fill();
    }

    fill() {
      const distances = this.races[this.race.value] || [];
      this.distance.length = 1;
      for (const d of distances) this.distance.add(new Option(d.l, d.u));
      this.distance.disabled = distances.length === 0;
      if (distances.length === 1) this.distance.selectedIndex = 1;
      this.update();
    }

    update() {
      const race = this.race.selectedOptions[0];
      this.go.href = this.distance.value || race?.dataset.url || this.dataset.all;
    }
  }

  if (!customElements.get('route-race-picker')) customElements.define('route-race-picker', RouteRacePicker);
  } catch(e) { console.error(e); }
})();

})();
